import type { FC } from 'react';
import React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const CaretUpIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M15.2929 12.2928L9.70713 17.8786C9.07716 18.5086 9.52333 19.5857 10.4142 19.5857H21.5858C22.4767 19.5857 22.9229 18.5086 22.2929 17.8786L16.7071 12.2928C16.3166 11.9023 15.6834 11.9023 15.2929 12.2928Z" />
  </BaseIcon>
);
